import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import Row from '../common/layout/row';
import Select from '../common/form/select';
import FormatUtils from '../common/formatUtils/FormatUtils';
import {
    setModoTela,
    initForm,
    setFiltro,
    getListaCooperativa,
    getListaEmpresa,
    getListaTurma,
    getListaRelatorioPresencaPorCooperativa,
    getListaRelatorioPresencaPorEmpresa,
    getListaRelatorioPresencaPorTurma
} from './relatorioActions';
import '../dashboard/dashboard.css';
import './relatorio.css';

const meses = [
    { id: '01', valor: 'Janeiro' },
    { id: '02', valor: 'Fevereiro' },
    { id: '03', valor: 'Março' },
    { id: '04', valor: 'Abril' },
    { id: '05', valor: 'Maio' },
    { id: '06', valor: 'Junho' },
    { id: '07', valor: 'Julho' },
    { id: '08', valor: 'Agosto' },
    { id: '09', valor: 'Setembro' },
    { id: '10', valor: 'Outubro' },
    { id: '11', valor: 'Novembro' },
    { id: '12', valor: 'Dezembro' }
];

class Relatorio extends Component {
    state = { linhaSelecionada: null };

    componentDidMount() {
        this.atualizar(this.props.filtro || {});
    }

    atualizar = (filtro = {}) => {
        this.props.setFiltro({ ...filtro });
        this.props.getListaCooperativa();
        this.props.getListaEmpresa();
        this.props.getListaTurma();
        this.props.getListaRelatorioPresencaPorCooperativa({ ...filtro });
        this.props.getListaRelatorioPresencaPorEmpresa({ ...filtro });
        this.props.getListaRelatorioPresencaPorTurma({ ...filtro });
    };

    formatarParticipacao = valor => FormatUtils.formatarValorTela(valor || 0, 2);

    renderParticipacao = valor => {
        const numero = Math.max(0, Math.min(Number(valor || 0), 100));
        return (
            <div className="report-participation">
                <div className="report-progress" aria-hidden="true">
                    <div className="report-progress-fill" style={{ width: `${numero}%` }} />
                </div>
                <strong>{this.formatarParticipacao(valor)}%</strong>
            </div>
        );
    };

    selecionarLinha = id => this.setState({ linhaSelecionada: id });

    renderEmpty = colSpan => (
        <tr>
            <td className="report-empty" colSpan={colSpan}>
                <i className="far fa-chart-bar" aria-hidden="true" />
                Nenhum registro encontrado para os filtros selecionados.
            </td>
        </tr>
    );

    renderReport = (title, subtitle, icon, count, headers, rows) => (
        <section className="dashboard-panel report-panel">
            <header className="dashboard-panel-header">
                <div className="dashboard-panel-title">
                    <i className={icon} aria-hidden="true" />
                    <div>
                        <h3>{title}</h3>
                        <span>{subtitle}</span>
                    </div>
                </div>
                <span className="report-count">{count} {count === 1 ? 'registro' : 'registros'}</span>
            </header>
            <div className="report-table-wrap">
                <table className="report-table">
                    <thead>
                        <tr>{headers.map(header => <th key={header}>{header}</th>)}</tr>
                    </thead>
                    <tbody>{rows}</tbody>
                </table>
            </div>
        </section>
    );

    render() {
        const filtro = this.props.filtro || {};
        const anoAtual = new Date().getFullYear();
        const anos = Array.from({ length: anoAtual - 2022 + 1 }, (_, index) => {
            const ano = String(2022 + index);
            return { id: ano, valor: ano };
        });
        const cooperativas = this.props.listaRelatorioPresencaPorCooperativa || [];
        const empresas = this.props.listaRelatorioPresencaPorEmpresa || [];
        const turmas = this.props.listaRelatorioPresencaPorTurma || [];
        const mesSelecionado = meses.find(item => item.id === filtro.mes);
        const periodo = `${mesSelecionado ? mesSelecionado.valor : 'Todos os meses'} de ${filtro.ano || anoAtual}`;
        const empresasFiltradas = (this.props.listaEmpresa || []).filter(item =>
            !filtro.id_cooperativa || String(item.id_cooperativa) === String(filtro.id_cooperativa)
        );
        const turmasFiltradas = (this.props.listaTurma || []).filter(item =>
            (!filtro.id_cooperativa || String(item.id_cooperativa) === String(filtro.id_cooperativa)) &&
            (!filtro.id_empresa || String(item.id_empresa) === String(filtro.id_empresa))
        );

        return (
            <Content>
                <main className="seft-dashboard report-page">
                    <section className="dashboard-hero report-hero">
                        <div>
                            <span className="dashboard-eyebrow">Análise de dados</span>
                            <h1>Relatórios de participação</h1>
                            <p>Consulte os resultados por cooperativa, empresa e turma.</p>
                        </div>
                        <div className="dashboard-period">
                            <span>Período selecionado</span>
                            <strong>{periodo}</strong>
                        </div>
                    </section>

                    <section className="dashboard-filter-card report-filter-card" aria-label="Filtros dos relatórios">
                        <div className="dashboard-filter-title">
                            <i className="fas fa-sliders-h" aria-hidden="true" />
                            Filtros de visualização
                        </div>
                        <Row>
                            <Select
                                options={[{ id: 'AMBAS', valor: 'Ambas' }, { id: 'INDIVIDUAL', valor: 'Individual' }, { id: 'COLETIVA', valor: 'Coletiva' }]}
                                label="Tipo de participação"
                                cols="12 6 4 4"
                                placeholder="Selecione"
                                value={filtro.tipo}
                                onChange={value => this.atualizar({ ...filtro, tipo: value })}
                            />
                            <Select options={anos} label="Ano" cols="12 6 4 4" placeholder="Selecione" value={filtro.ano} onChange={value => this.atualizar({ ...filtro, ano: value })} />
                            <Select options={meses} label="Mês" cols="12 6 4 4" placeholder="Selecione" value={filtro.mes} onChange={value => this.atualizar({ ...filtro, mes: value })} />
                            <Select
                                name="id_cooperativa"
                                options={this.props.listaCooperativa || []}
                                label="Cooperativa"
                                cols="12 6 4 4"
                                placeholder="Todas as cooperativas"
                                value={filtro.id_cooperativa}
                                onChange={value => this.atualizar({ ...filtro, id_cooperativa: value, id_empresa: null, id_turma: null })}
                            />
                            <Select
                                name="id_empresa"
                                options={empresasFiltradas}
                                label="Empresa"
                                cols="12 6 4 4"
                                placeholder="Todas as empresas"
                                value={filtro.id_empresa}
                                onChange={value => this.atualizar({ ...filtro, id_empresa: value, id_turma: null })}
                            />
                            <Select
                                name="id_turma"
                                options={turmasFiltradas}
                                label="Turma"
                                cols="12 6 4 4"
                                placeholder="Todas as turmas"
                                value={filtro.id_turma}
                                onChange={value => this.atualizar({ ...filtro, id_turma: value })}
                            />
                        </Row>
                    </section>

                    <div className="report-summary" aria-label="Resumo dos relatórios">
                        <span><i className="fas fa-handshake" aria-hidden="true" /><strong>{cooperativas.length}</strong> cooperativas</span>
                        <span><i className="fas fa-building" aria-hidden="true" /><strong>{empresas.length}</strong> empresas</span>
                        <span><i className="fas fa-users" aria-hidden="true" /><strong>{turmas.length}</strong> turmas</span>
                    </div>

                    <div className="dashboard-reports report-list">
                        {this.renderReport(
                            'Participação por cooperativa',
                            'Visão consolidada por cooperativa',
                            'fas fa-handshake',
                            cooperativas.length,
                            ['Cooperativa', 'Participação'],
                            cooperativas.length ? cooperativas.map((item, index) => (
                                <tr key={item.id || index} className={this.state.linhaSelecionada === `cooperativa-${index}` ? 'is-selected' : ''} onClick={() => this.selecionarLinha(`cooperativa-${index}`)}>
                                    <td><strong className="report-primary-cell">{item.nome_cooperativa}</strong></td>
                                    <td className="report-participation-cell">{this.renderParticipacao(item.participacao)}</td>
                                </tr>
                            )) : this.renderEmpty(2)
                        )}

                        {this.renderReport(
                            'Participação por empresa',
                            'Detalhamento de empresas e cooperativas',
                            'fas fa-building',
                            empresas.length,
                            ['Cooperativa', 'Empresa', 'Participação'],
                            empresas.length ? empresas.map((item, index) => (
                                <tr key={item.id || index} className={this.state.linhaSelecionada === `empresa-${index}` ? 'is-selected' : ''} onClick={() => this.selecionarLinha(`empresa-${index}`)}>
                                    <td>{item.nome_cooperativa}</td>
                                    <td><strong className="report-primary-cell">{item.nome_empresa}</strong></td>
                                    <td className="report-participation-cell">{this.renderParticipacao(item.participacao)}</td>
                                </tr>
                            )) : this.renderEmpty(3)
                        )}

                        {this.renderReport(
                            'Participação por turma',
                            'Detalhamento de participação das turmas',
                            'fas fa-users',
                            turmas.length,
                            ['Cooperativa', 'Empresa', 'Turma', 'Participação'],
                            turmas.length ? turmas.map((item, index) => (
                                <tr key={item.id || index} className={this.state.linhaSelecionada === `turma-${index}` ? 'is-selected' : ''} onClick={() => this.selecionarLinha(`turma-${index}`)}>
                                    <td>{item.nome_cooperativa}</td>
                                    <td>{item.nome_empresa}</td>
                                    <td><strong className="report-primary-cell">{item.competencia}</strong></td>
                                    <td className="report-participation-cell">{this.renderParticipacao(item.participacao)}</td>
                                </tr>
                            )) : this.renderEmpty(4)
                        )}
                    </div>
                </main>
            </Content>
        );
    }
}

const mapStateToProps = state => ({
    sessao: state.auth.usuario,
    modoTela: state.relatorio.modoTela,
    filtro: state.relatorio.filtro,
    listaCooperativa: state.relatorio.listaCooperativa,
    listaEmpresa: state.relatorio.listaEmpresa,
    listaTurma: state.relatorio.listaTurma,
    listaRelatorioPresencaPorCooperativa: state.relatorio.listaRelatorioPresencaPorCooperativa,
    listaRelatorioPresencaPorEmpresa: state.relatorio.listaRelatorioPresencaPorEmpresa,
    listaRelatorioPresencaPorTurma: state.relatorio.listaRelatorioPresencaPorTurma
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoTela,
    initForm,
    setFiltro,
    getListaCooperativa,
    getListaEmpresa,
    getListaTurma,
    getListaRelatorioPresencaPorCooperativa,
    getListaRelatorioPresencaPorEmpresa,
    getListaRelatorioPresencaPorTurma
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Relatorio);
